export default __webpack_public_path__ + "static/long_x_cart-3a3badf3e220d7a69b267eda554d58f7.svg";